import React, { useState } from 'react'
import { connect } from 'react-redux'
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import DeleteModal from '../Shared/DeleteModal'
import { handleDetailsClick, handleDeleteCompany } from '../actions/companyActions'
import { AzureAD } from 'react-aad-msal'
import { authProvider } from '../../services/authProvider'

const DropDownTableItem = ({ row, handleDeleteCompany, handleDetailsClick }) => {
  const [dropdownOpen, setOpen] = useState(false)
  const [modal, setModal] = useState(false)

  const toggle = () => setOpen(!dropdownOpen)
  const toggleModal = () => setModal(!modal)

  return (
    <AzureAD provider={authProvider}>
      {({ login, logout, authenticationState, accountInfo }) => {
        let isAdmin = false
        if (accountInfo && accountInfo.account && accountInfo.account.idToken && accountInfo.account.idToken.roles) {
          if (accountInfo.account.idToken.roles.includes('Admin')) {
            isAdmin = true
          }
        }
        return (
          <React.Fragment>
            <ButtonDropdown size="sm" isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="primary" caret>
                Actions
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleDetailsClick(row.id)}>Details</DropdownItem>
                {isAdmin && <DropdownItem onClick={toggleModal}>Delete</DropdownItem>}
              </DropdownMenu>
            </ButtonDropdown>
            {isAdmin && (
              <DeleteModal
                modal={modal}
                toggleModal={toggleModal}
                handleDeleteCompany={handleDeleteCompany}
                name={row.companyName}
                id={row.id}
              />
            )}
          </React.Fragment>
        )
      }}
    </AzureAD>
  )
}
const mapDispatchToProps = {
  handleDetailsClick,
  handleDeleteCompany,
}

export default connect(null, mapDispatchToProps)(DropDownTableItem)
